module.exports = __webpack_public_path__ + "static/media/eus-flag.904eb5cb.png";